// Minnesotaänger Mini App — app shell (trimmed from telegram-tt App.tsx, see PROVENANCE).
// No auth/lock/inactive screens: the Mini App entry is the chat UI itself.

import { useLayoutEffect } from '../lib/teact/teact';

import { updateSizes } from '../util/windowSize';

import Main from './main/Main';

import styles from './App.module.scss';

const App = () => {
  useLayoutEffect(() => {
    updateSizes();
    // telegram-tt App.tsx semantic: the wallpaper lives on <body> via
    // App.module.scss `.bg` (chat pattern + chat-bg-br.png under
    // html.theme-light). --theme-background-color was already set by
    // initAppEnvironment() before the first render. (v1 bug fixed: the old
    // `styles.App` class never existed, so `.bg` was never mounted.)
    document.body.classList.add(styles.bg);
  }, []);

  return (
    <Main />
  );
};

export default App;
